import appointmentReducer from '@features/appointment/reducer/appointmentSlice';
import calendarsReducer from '@features/calendars/reducer/calendarSlice';
import eligibilityReducer from '@features/eligibility/eligibilitySlice';
import geomatchReducer from '@features/geomatch/reducer/geoMatchSlice';
import orderReducer from '@features/order/reducer/orderSlice';
import profileReducer from '@features/profiles/profileSlice';
import historyReducer from '@features/siteStatusV2/reducer/historySlice';
import orderListReducer from '@features/siteStatusV2/reducer/orderListSlice';
import reportReducer from '@features/siteStatusV2/reducer/reportSlice';
import siteReducer from '@features/siteStatusV2/reducer/siteSlice';
import ticketReducer from '@features/siteStatusV2/reducer/ticketSlice';
import userReducer from '@features/siteStatusV2/reducer/userSlice';
import zonesGeoReducer from '@features/zonesGeo/reducer/zonesGeoSlice';
import referenceReducer from '@features/zonesGeoReferences/reducer/referencesSlice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';

import navigationReducer from '../components/layout/navigationReducer';

export const reducer = combineReducers({
  appointment: appointmentReducer,
  calendars: calendarsReducer,
  eligibility: eligibilityReducer,
  geomatch: geomatchReducer,
  history: historyReducer,
  navigation: navigationReducer,
  order: orderReducer,
  orderList: orderListReducer,
  profile: profileReducer,
  report: reportReducer,
  site: siteReducer,
  ticket: ticketReducer,
  user: userReducer,
  zoneGeoReferences: referenceReducer,
  zonesGeo: zonesGeoReducer
});

export const store = configureStore({ reducer });

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
